<template>
  <div class="row m-b-lg m-t-lg wrapper">
    <div class="col-md-12">
      <h3 class="col-lg-6"><e-txt :text="order.name" @input="updateOrder($event, 'name')" close-on-save="true"></e-txt></h3>
    </div>
    <div class="col-md-12 m-t-sm">
      <div class="row" v-if="order.client">
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Client</td>
              <td>
                <v-select v-if="user.admin" :options="filters.clients" label="name" index="id" v-model="order.client.id" @input="updateOrder($event, 'client')">
                </v-select>
                <span v-else><strong>{{ order.client.name }}</strong></span>
              </td>
            </tr>
            <tr>
              <td>Group</td>
              <td>
                <v-select v-if="user.admin && filters.groupsByClient" :options="filters.groupsByClient[order.client.id]" label="name" index="id" :value="order.group ? order.group.id : null" @input="updateOrder($event, 'group')">
                </v-select>
                <span v-else><strong>{{ order.client.name }}</strong></span>
              </td>
            </tr>
            <tr>
              <td>Type</td>
              <td>
                <v-select :options="['build','link','fix','content']" multiple :value="order.types" @input="updateOrder($event, 'types')"></v-select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Status:</td>
              <td>
                <e-txt :text="order.status" type="select" @input="updateOrder($event, 'status')" close-on-save="true" :options="['open','completed']"></e-txt>
              </td>
            </tr>
            <tr>
              <td>Start:</td>
              <td>
                <e-txt :text="order.start.date" date-format="DD-MM-YYYY" return-date-format="DD-MM-YYYY" type="date" @input="updateOrder($event, 'start')" close-on-save="true"></e-txt>
              </td>
            </tr>
            <tr>
              <td>Duration:</td>
              <td>
                <e-txt :text="order.duration" type="int" @input="updateOrder($event, 'duration')" close-on-save="true"></e-txt>
              </td>
            </tr>
            <tr>
              <td>Credits:</td>
              <td>
                <e-txt :text="order.credits" type="int" @input="updateOrder($event, 'credits')" close-on-save="true"></e-txt>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <thead>
            <tr>
              <th colspan="2">Sources</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="order.filters.clients">
              <td>Clients</td>
              <td>
                <span class="label label-success m-r-xs" v-for="c in order.filters.clients" :key="c.id">{{ c.name }}</span>
              </td>
            </tr>
            <tr v-if="order.filters.groups">
              <td>Groups</td>
              <td>
                <span class="label label-success m-r-xs" v-for="g in order.filters.groups" :key="g.id">{{ g.name }}</span>
              </td>
            </tr>
            <tr v-if="order.filters.groupsNot">
              <td>Groups Not</td>
              <td>
                <span class="label label-success m-r-xs" v-for="g in order.filters.groupsNot" :key="'gnot-' + g.id">{{ g.name }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-3">
          <table class="table small m-b-xs" v-if="order.taskCounts">
            <thead>
            <tr>
              <th colspan="2">Tasks</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="status in taskStatuses" :key="status">
              <td>{{ status }}</td>
              <td><b>{{ order.taskCounts[status] || 0 }}</b></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { ORDER_SET } from '../../../../store/mutation-types'

export default {
  data () {
    return {
      taskStatuses: [
        'created',
        'assigned',
        'completed',
        'closed'
      ]
    }
  },
  components: {
    eTxt: EditText
  },
  computed: {
    ...mapGetters({
      order: 'getMaintenanceOrder',
      user: 'getUser',
      filters: 'getFilters'
    })
  },
  mounted () {
    if (!this.filters.length) {
      this.$store.dispatch('loadFilters')
    }
  },
  updated () {
    document.title = this.order.name + ' :: Maintenance Order :: PBN360 by Aphex Media'
  },
  methods: {
    updateOrder (val, prop) {
      let data = {}
      data[prop] = val
      axios.patch(`/maintenance/order/${this.order.id}`, data)
        .then(r => {
          this.$store.commit(ORDER_SET, r.data.order)
          this.$toastr.success(`${prop} has been updated`, 'Yes!')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order/Header.vue